/* eslint-disable no-undef */

import loadScript from '../utils/load_script';

export default async function loadTracker() {
  await loadScript(process.env.TAPPX_URL_TRACKER);
}
